import React from 'react';
import { InstagramIcon, FacebookIcon, TwitterIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-espresso border-t border-espresso-light py-12 px-4" data-id="element-86">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-87">
        <a href="#" className="font-serif text-3xl text-cream mb-6" data-id="element-88">
          Be Clinical
        </a>

        <p className="font-sans text-cream/70 text-sm md:text-base mb-8 max-w-sm" data-id="element-89">
          San Ramon, CA
          <br data-id="element-90" />
          Elevating natural beauty through regenerative science.
        </p>

        <div className="flex space-x-6 mb-10" data-id="element-91">
          <a href="#" className="text-cream/70 hover:text-gold transition-colors" aria-label="Instagram" data-id="element-92">
            <InstagramIcon className="w-5 h-5" data-id="element-93" />
          </a>
          <a href="#" className="text-cream/70 hover:text-gold transition-colors" aria-label="Facebook" data-id="element-94">
            <FacebookIcon className="w-5 h-5" data-id="element-95" />
          </a>
          <a href="#" className="text-cream/70 hover:text-gold transition-colors" aria-label="Twitter" data-id="element-96">
            <TwitterIcon className="w-5 h-5" data-id="element-97" />
          </a>
        </div>

        <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8 font-sans text-sm text-cream/50" data-id="element-98">
          <a href="#" className="hover:text-cream transition-colors" data-id="element-99">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-100">
            Terms of Service
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-101">
            Contact Us
          </a>
        </div>

        <p className="font-sans text-xs text-cream/40 mt-10" data-id="element-102">
          &copy; {new Date().getFullYear()} Be Clinical San Ramon. All rights
          reserved.
        </p>
      </div>
    </footer>;
}